import{useState}from'react'
import{jsPDF}from'jspdf'
import{supabase}from'../supabase'

export default function Settlement({event,deal,contacts,tiers}){
const[grossRevenue,setGrossRevenue]=useState('')
const[ticketingFees,setTicketingFees]=useState('')
const[merchGross,setMerchGross]=useState('')
const[notes,setNotes]=useState('')
const[saving,setSaving]=useState(false)
const[settlement,setSettlement]=useState(null)

const mgmt=contacts.find(c=>c.role==='agent'||c.role==='tour_manager')
const artist=contacts.find(c=>c.role==='artist')
function downloadPDF(){
const doc=new jsPDF()
const lines=doc.splitTextToSize(settlement.text,180)
doc.setFont('helvetica')
doc.setFontSize(11)
doc.text(lines,15,20)
doc.save(event.name+'-settlement.pdf')}
function calculate(){
const gross=parseFloat(grossRevenue)||0
const fees=parseFloat(ticketingFees)||0
const merch=parseFloat(merchGross)||0
const netBox=gross-fees
const guarantee=deal?parseFloat(deal.guarantee_amount)||0:0
const doorPct=deal?parseFloat(deal.door_percentage)||0:0
const travel=deal?parseFloat(deal.travel_cap)||0:0
const hospitality=deal?parseFloat(deal.hospitality_buyout)||0:0
const merchCut=deal?parseFloat(deal.merch_percentage)||0:0
let artistPayment=guarantee
if(deal&&deal.deal_type==='vs_door'){
const doorAmount=netBox*(doorPct/100)
artistPayment=Math.max(guarantee,doorAmount)}
if(deal&&deal.deal_type==='door_deal'){
artistPayment=netBox*(doorPct/100)}
const merchVenueCut=merch*(merchCut/100)
const totalToArtist=artistPayment+travel+hospitality
return{gross,fees,netBox,guarantee,artistPayment,travel,hospitality,merch,merchVenueCut,totalToArtist}}

async function handleSave(){
setSaving(true)
const calc=calculate()
const settlementText=`SETTLEMENT SHEET

Event: ${event.name}
Artist: ${event.artist_name}
Date: ${new Date(event.event_date).toLocaleDateString('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'})}

BOX OFFICE
Gross Revenue: $${calc.gross.toFixed(2)}
Ticketing Fees: -$${calc.fees.toFixed(2)}
Net Box Office: $${calc.netBox.toFixed(2)}

${calc.merch>0?'MERCHANDISE\nGross Merch Sales: $'+calc.merch.toFixed(2)+'\nVenue Cut: $'+calc.merchVenueCut.toFixed(2)+'\n':''}
ARTIST PAYMENT
Guarantee: $${calc.guarantee.toFixed(2)}
${deal&&deal.deal_type==='vs_door'?'Door Percentage Applied: $'+calc.artistPayment.toFixed(2):''}
Travel Reimbursement: $${calc.travel.toFixed(2)}
Hospitality Buyout: $${calc.hospitality.toFixed(2)}
TOTAL DUE TO ARTIST: $${calc.totalToArtist.toFixed(2)}

${notes?'NOTES\n'+notes:''}

Agreed and accepted:

Presenter: _________________________ Date: _________

Artist/Representative: _________________________ Date: _________`

const emailDraft=`Subject: Settlement - ${event.name} - ${new Date(event.event_date).toLocaleDateString()}

Dear ${mgmt?mgmt.name:artist?artist.name:'Team'},

Please find the settlement details for ${event.artist_name}'s performance at ${event.name}.

Total Due to Artist: $${calc.totalToArtist.toFixed(2)}

Payment will be processed within 24 hours. Please review the attached settlement sheet and confirm receipt.

Best regards,
Greenroom`

await supabase.from('settlements').upsert({
event_id:event.id,
gross_revenue:calc.gross,
ticketing_fees:calc.fees,
net_box_office:calc.netBox,
artist_payment:calc.artistPayment,
merch_gross:calc.merch,
merch_venue_cut:calc.merchVenueCut,
promoter_net:calc.netBox-calc.totalToArtist,
settlement_pdf_url:null,
email_draft:emailDraft,
notes:notes
})
setSettlement({text:settlementText,email:emailDraft,calc})
setSaving(false)}

return(<div>
<div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'12px',marginBottom:'1rem'}}>
<div>
<label style={{fontSize:'12px',color:'#888',display:'block',marginBottom:'4px'}}>Gross Revenue ($)</label>
<input className='input' type='number' placeholder='0.00' value={grossRevenue} onChange={e=>setGrossRevenue(e.target.value)}/>
</div>
<div>
<label style={{fontSize:'12px',color:'#888',display:'block',marginBottom:'4px'}}>Ticketing Fees ($)</label>
<input className='input' type='number' placeholder='0.00' value={ticketingFees} onChange={e=>setTicketingFees(e.target.value)}/>
</div>
<div>
<label style={{fontSize:'12px',color:'#888',display:'block',marginBottom:'4px'}}>Merch Gross ($)</label>
<input className='input' type='number' placeholder='0.00' value={merchGross} onChange={e=>setMerchGross(e.target.value)}/>
</div>
<div>
<label style={{fontSize:'12px',color:'#888',display:'block',marginBottom:'4px'}}>Notes</label>
<input className='input' placeholder='Any notes...' value={notes} onChange={e=>setNotes(e.target.value)}/>
</div>
</div>
<button className='btn-primary' onClick={handleSave} disabled={saving}>{saving?'Calculating...':'Generate Settlement'}</button>
{settlement&&(
<div style={{marginTop:'1.5rem'}}>
<div style={{background:'#f8fdf9',border:'1px solid #c8e6d4',borderRadius:'8px',padding:'1rem',marginBottom:'1rem'}}>
<p style={{fontSize:'13px',fontWeight:'600',marginBottom:'8px'}}>Total Due to Artist</p>
<p style={{fontSize:'28px',fontWeight:'600',color:'#1a6b4a'}}>${settlement.calc.totalToArtist.toFixed(2)}</p>
</div>
<pre style={{background:'#f9f9f9',border:'1px solid #eee',borderRadius:'8px',padding:'1.5rem',fontSize:'12px',lineHeight:'1.8',whiteSpace:'pre-wrap',fontFamily:'Georgia,serif',marginBottom:'1rem'}}>{settlement.text}</pre>
<p style={{fontSize:'13px',fontWeight:'600',marginBottom:'8px'}}>Email Draft</p>
<pre style={{background:'#f0f7ff',border:'1px solid #c8dff4',borderRadius:'8px',padding:'1.5rem',fontSize:'12px',lineHeight:'1.8',whiteSpace:'pre-wrap',marginBottom:'1rem'}}>{settlement.email}</pre>
<div style={{display:'flex',gap:'8px'}}>
<button className='btn-secondary' onClick={()=>navigator.clipboard.writeText(settlement.text)}>Copy Settlement</button>
<button className='btn-secondary' onClick={downloadPDF}>Download PDF</button>
<button className='btn-secondary' onClick={()=>navigator.clipboard.writeText(settlement.email)}>Copy Email</button>
</div>
</div>
)}
</div>)}